import { useContext, useState } from 'react';
import { Form, Button, Modal } from 'react-bootstrap';
import Common from '../../shared/Common';

import './style.css';
import { DictionaryContext } from '../../../App';

export interface IAddCategoryModalProps {
  show: boolean;
  onHide: () => void;
  onSave: () => void;
}

function AddIncomeCategoryModal(props: IAddCategoryModalProps) {
  const [incomeCategoryName, setIncomeCategoryName] = useState<string>('');
  const { reloadIncomeCategories } = useContext(DictionaryContext);

  const addCategory = async () => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ incomeCategoryName }),
    };
    const response = await Common.authorizedFetch('api/categories/addIncomeCategory', requestOptions);
    const data = await response.json();
    if (!data.success) {
      alert(data.errors);
    } else {
      if (reloadIncomeCategories) {
        reloadIncomeCategories();
      }
      setIncomeCategoryName('');
      props.onHide();
      props.onSave();
    }
  };

  return (
    <Modal centered show={props.show} onHide={props.onHide} aria-labelledby='contained-modal-title-vcenter'>
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'>Dodaj nową kategorię przychodu</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId='formBasicCategoryName'>
            <Form.Label>Nazwa kategorii</Form.Label>
            <Form.Control
              type='text'
              placeholder='Wpisz nazwę'
              onChange={(e: any) => {
                setIncomeCategoryName(e.target.value);
              }}
            />
            <Form.Text className='text-muted'>Nazwa kategorii określająca kategorię przychodu.</Form.Text>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='dark' onClick={props.onHide}>
          Zamknij
        </Button>
        <Button variant='success' onClick={addCategory}>
          Zapisz
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AddIncomeCategoryModal;
